module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.to_editor === 'true') ? _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.matterTypes), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/choosetype/true/' + t._id + '/none'
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0) : _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.matterTypes), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/choosetype/false/' + t._id + '/' + _vm.matter_id
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d556613c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/chooseDocCategory.vue
// module id = 523
// module chunks = 1